// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip-with-input {
  display: inline-flex;
  align-items: center;
  cursor: text;
  padding: 15px 16px;
  color: var(--color_neutral_900);
  font-size: 12px;
  border: 1px solid transparent;
}
.chip-with-input.display-mode {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  border: 1px dashed var(--gray_light2);
  border-radius: 24px;
}
.chip-with-input .input-field {
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
  background: transparent;
  width: 100%;
}
.chip-with-input .input-field::placeholder {
  color: var(--color_neutral_400);
}`, "",{"version":3,"sources":["webpack://./src/components/chip-with-input/chip-with-input.styles.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,6BAAA;AACF;AACE;EACE,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,qCAAA;EACA,mBAAA;AACJ;AAEE;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;AAAJ;AAEI;EACE,+BAAA;AAAN","sourcesContent":[".chip-with-input {\n  display: inline-flex;\n  align-items: center;\n  cursor: text;\n  padding: 15px 16px;\n  color: var(--color_neutral_900);\n  font-size: 12px;\n  border: 1px solid transparent;\n\n  &.display-mode {\n    width: fit-content;\n    border: 1px dashed var(--gray_light2);\n    border-radius: 24px;\n  }\n\n  .input-field {\n    border: none;\n    outline: none;\n    margin: 0;\n    padding: 0;\n    background: transparent;\n    width: 100%;\n\n    &::placeholder {\n      color: var(--color_neutral_400);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
